import _ from 'lodash';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';

function Footer() {
  const { config, setConfig, setUser } = useStorage();
  //   const startRef = useRef();
  const timeoutRef = useRef();
  const classes = useStyles({ config });
  const { t } = useTranslation();

  const onTouchStart = () => {
    // startRef.current = dayjs();
    // alert("x");

    timeoutRef.current = setTimeout(() => {
      // eslint-disable-next-line no-alert, no-undef
      alert(
        t(
          config.experiment
            ? 'footer.experiment-done'
            : 'footer.experiment-mode'
        )
      );
      setConfig({
        ..._.clone(config),
        experiment: !config.experiment,
      });
      setUser(null);

      // eslint-disable-next-line no-undef
      window.location.reload();
    }, 3000);
  };

  const onTouchEnd = () => {
    if (timeoutRef.current != null && _.isFunction(timeoutRef.current)) {
      timeoutRef.current();
    }

    // const seconds = dayjs().diff(startRef.current, "seconds");

    // if (seconds > 2) {
    //   alert(experiment ? "Modo de experimento" : "Experimento finalizado");
    //   setExperiment(!experiment);
    // }
  };

  return (
    <div className={classes.container}>
      <button
        className={classes.deadZone}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onMouseDown={onTouchStart}
        onMouseUp={onTouchEnd}
        type="button"
      >
        {' '}
      </button>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    // border: '1px solid red',
    paddingBottom: 60,
  },
  deadZone: {
    // flex: 1,
    width: 28,
    height: 28,
    margin: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.verticalMargin + 8,
    backgroundColor: ({ config }) =>
      config.experiment ? '#ffffff20' : '#ffffff05',
    // backgroundColor: ({ experiment }) => (experiment ? "red" : "blue"),
    border: 0,
    borderRadius: 20,
  },
});

export { Footer };
